import { Smartphone } from "lucide-react";
import { Card } from "../../ui/card";

interface ApplicationMetadataProps {
  data: any;
  loading: boolean;
  error: string | null;
}

export function ApplicationMetadata({
  data,
  loading,
  error,
}: ApplicationMetadataProps) {
  return (
    <Card className="hover:shadow-lg transition-shadow duration-200 overflow-hidden p-6 border border-gray-800">
      <h2 className="text-lg font-semibold font-heading mb-4 flex items-center text-superone-charcoal">
        <Smartphone className="mr-2 h-5 w-5 text-pink-500" />
        Application Metadata
      </h2>
      <span className="text-yellow-700 bg-yellow-100 rounded px-2 py-1 font-medium mb-4 inline-block">
        Data is currently in pre-representation stage.
      </span>
      <div className="flex flex-col gap-4">
        {loading && <div className="text-gray-400">Loading...</div>}
        {error && (
          <span className="text-red-700 bg-red-100 rounded px-2 py-1 font-medium mb-4 inline-block">
            {error}
          </span>
        )}
        {data && (
          <>
            <pre className="bg-gray-100 text-xs p-2 rounded overflow-x-auto max-h-100">
              {JSON.stringify(data, null, 2)}
            </pre>
          </>
        )}
      </div>
    </Card>
  );
}
